<template>
	<div class="md-layout-item">
		<div class="modal-content">
			<h3 class="font_bold">{{ $t("contract.process.title") }}</h3>
			<div class="flex flex_center">
				<span>{{ $t("contract.process.title.tip") }}：</span>
				<a :href="processData.downloadUrl" target="_blank" class="font_bold">
					{{ processData.downloadName }}
					<i class="fa fa-download"></i>
				</a>
			</div>

      <table class="contract_summary" style="background-color: #cbe9fe;">
        <tr class="text_center font_bold">
          <td colspan="2"><h3 class="font_bold" style="margin-bottom: 15px">{{ $t("contract.process.title.tip2") }}</h3></td>
        </tr>
        <tr>
          <td class="text_right"> <span class="font_bold font_base">
            {{ $t("contract.process.title.fee") }}:</span>
          </td>
          <td><span>{{ feeRate }}% {{ $t("contract.process.title.feeText") }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base">
          {{ $t("contract.process.title.total") }}:</span></td>
          <td><span>{{ formatAmount(getSalesFormAmount() && (getSalesFormAmount() / 100.00 * (feeRate)) || 0 )}}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base">{{
              $t("contract.process.title.totalText")
            }}:</span>
          </td>
          <td>
            <md-radio v-if="!isDebtor"
                style="margin-left: 10px"
                :value="enumDef.obligatory.Debtor"
                v-model="contractData.feeObligatory"
                :class="{ 'md-error': errors.first('debtor') }"
                v-validate="{required: true}"
                data-vv-name="debtor"
                required>
              {{ $t("common.debtor") }}
            </md-radio>
            <md-radio v-if="!isDebtor"
                :value="enumDef.obligatory.Supplier"
                v-model="contractData.feeObligatory"
                :class="{ 'md-error': errors.first('supplier') }"
                v-validate="{required: true}"
                data-vv-name="supplier"
                required>{{ $t("common.supplier") }}
            </md-radio>
            <span v-else>{{formatAsLocalizedEnum(contractData.feeObligatory)}}</span>
          </td>
        </tr>
      </table>

      <table class="contract_summary">
        <tr class="text_right font_bold">
          <td><h3 class="font_bold" style="margin-bottom: 15px">{{ $t("contract.process.sales.summary.title") }}</h3></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right"> <span class="font_bold font_base"> {{ $t("common.debtor") }}:</span></td>
          <td><span>{{ getSalesForm("debtor") && getSalesForm("debtor").name || contractData.debtor && contractData.debtor.name }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("seller.upload.DebtorContact") }}:</span></td>
          <td><span>{{ getSalesForm("debtorContact") && getSalesForm("debtorContact").name || contractData.debtorContact && contractData.debtorContact.name }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.contractNumber") }}:</span></td>
          <td><span>{{ getSalesForm("invoiceNumber") || contractData.invoiceNumber }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.contractDate") }}:</span></td>
          <td><span>{{ getSalesForm("invoiceDate") || contractData.invoiceDate }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.amount") }}:</span></td>
          <td><span>{{ formatAmount(getSalesFormAmount()) }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.currency") }}:</span></td>
          <td><span>{{ getSalesForm("currency") || contractData.currency }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.estimatedDeliveryDate") }}:</span></td>
          <td><span>{{ getSalesForm("shipment") && getSalesForm("shipment").estimatedDeliveryDate || contractData.shipment && contractData.shipment.estimatedDeliveryDate }}</span></td>
        </tr>
        <tr>
          <td class="text_right" style="padding-bottom: 15px"><span class="font_bold font_base"> {{ $t("contract.process.daysTolerance") }}:</span></td>
          <td style="padding-bottom: 15px"><span>{{ getSalesForm("shipment") && getSalesForm("shipment").deliveryDateTolerance || contractData.shipment && contractData.shipment.deliveryDateTolerance }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.delivery") }}</span></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.companyName") }}:</span></td>
          <td><span>{{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").companyName || contractData.shipment && contractData.shipment.toAddress.companyName
            }}</span></td>
        </tr>
		  <tr>
			  <td class="text_right"><span class="font_bold font_base"> {{ $t("common.name") }}:</span></td>
			  <td><span>{{
					  getShipmentFormsShipment("toAddress") && getShipmentFormsShipment("toAddress").contact.firstName || contractData.shipment && contractData.shipment.toAddress.contact.firstName
				  }} {{
					  getShipmentFormsShipment("toAddress") && getShipmentFormsShipment("toAddress").contact.lastName || contractData.shipment && contractData.shipment.toAddress.contact.lastName
				  }}</span></td>
		  </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.address") }}:</span></td>
          <td><span>{{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").streetName || contractData.shipment && contractData.shipment.toAddress.streetName
            }} {{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").streetNumber || contractData.shipment && contractData.shipment.toAddress.streetNumber
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("Completion.Company.AddressAddon") }}:</span></td>
          <td><span>
			  {{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").addressExtension || contractData.shipment && contractData.shipment.toAddress.addressExtension
            }}
		  </span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.postalCode") }}:</span></td>
          <td><span>{{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").zipCode || contractData.shipment && contractData.shipment.toAddress.zipCode
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.city") }}:</span></td>
          <td><span>{{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").city || contractData.shipment && contractData.shipment.toAddress.city
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.country") }}:</span></td>
          <td><span>{{
              getSalesFormsShipment("toAddress") && getSalesFormsShipment("toAddress").country || contractData.shipment && contractData.shipment.toAddress.country
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("contract.process.salesContractDocument") }}:</span></td>
          <td><span>{{ getSalesForm("invoiceDocument") && getSalesForm("invoiceDocument").fileName || contractData.invoiceDocument && contractData.invoiceDocument.fileName }}</span></td>
        </tr>
        <tr class="text_right font_bold">
          <td></td>
          <td></td>
        </tr>
        <tr class="text_right font_bold">
          <td><h3 class="font_bold" style="margin-bottom: 15px; margin-top: 15px">{{ $t("contract.process.shipment.summary.title") }}</h3></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.productGroup") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("productGroupName") || contractData.shipment && contractData.shipment.productGroupName
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.productDescription") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("productDescription") || contractData.shipment && contractData.shipment.productDescription
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.transport") }}:</span></td>
          <td><span>{{ getModesOfTransportOfShipmentForm() && getModesOfTransportOfShipmentForm().filter(m => m.vModel === true).map(m => m.key).toString() || contractData.shipment && contractData.shipment.selectedModesOfTransport.toString() }}</span></td>
        </tr>
        <tr>
          <td style="padding-top: 15px" class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.paymentTip") }}</span></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.incoterm") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("incoTerms") || contractData.shipment && contractData.shipment.incoTerms
            }}</span></td>
        </tr>
        <tr>
          <td style="padding-top: 15px" class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.dapCoordinates") }}</span></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.latitude") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("destination") && getShipmentFormsShipment("destination").latitude || contractData.shipment && contractData.shipment.destination.latitude
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.longitude") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("destination") && getShipmentFormsShipment("destination").longitude || contractData.shipment && contractData.shipment.destination.longitude
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.tolerance") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("destination") && getShipmentFormsShipment("destination").radius || contractData.shipment && contractData.shipment.destination.radius
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right" style="padding-top: 15px"><span class="font_bold font_base"> {{ $t("trackPay.shipment.numberOfTrackersHeader") }}</span></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right" style="padding-bottom: 15px"><span class="font_bold font_base"> {{ $t("trackPay.shipment.numberOfTrackers") }}:</span></td>
          <td style="padding-bottom: 15px"><span>{{
              getShipmentFormsShipment("numberOfDevices") || contractData.shipment && contractData.shipment.numberOfDevices
            }}</span></td>
        </tr>
		<tr>
			<td class="text_right" style="padding-top: 15px"><span
				class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.trackerReceiverAddress") }}</span></td>
			<td></td>
		</tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.companyName") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").companyName || contractData.shipment && contractData.shipment.fromAddress.companyName
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.name") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").contact.firstName || contractData.shipment && contractData.shipment.fromAddress.contact.firstName
            }} {{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").contact.lastName || contractData.shipment && contractData.shipment.fromAddress.contact.lastName
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.address") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").streetName || contractData.shipment && contractData.shipment.fromAddress.streetName
            }} {{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").streetNumber || contractData.shipment && contractData.shipment.fromAddress.streetNumber
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("Completion.Company.AddressAddon") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").addressExtension || contractData.shipment && contractData.shipment.fromAddress.addressExtension
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.contractsEditModal.postalCode") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").zipCode || contractData.shipment && contractData.shipment.fromAddress.zipCode
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.city") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").city || contractData.shipment && contractData.shipment.fromAddress.city
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.country") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").country || contractData.shipment && contractData.shipment.fromAddress.country
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.phone") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").contact.phone || contractData.shipment && contractData.shipment.fromAddress.contact.phone
            }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("common.email") }}:</span></td>
          <td><span>{{
              getShipmentFormsShipment("fromAddress") && getShipmentFormsShipment("fromAddress").contact.email || contractData.shipment && contractData.shipment.fromAddress.contact.email
            }}</span></td>
        </tr>
        <tr class="text_right font_bold">
          <td><h3 class="font_bold" style="margin-bottom: 15px; margin-top: 15px">{{ $t("contract.process.tracker.summary.title") }}</h3></td>
          <td></td>
        </tr>
        <tr>
          <td class="text_right" style="padding-bottom: 15px"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.tracker") }}:</span></td>
          <td style="padding-bottom: 15px"><span>{{ getTrackerForm() && getTrackerForm().shipment && getTrackerForm().shipment.deviceProfileId || contractData.shipment && contractData.shipment.deviceProfileId }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("contract.process.tracker.deviceAndConfig") }}</span></td>
          <td><span>{{  }}</span></td>
        </tr>
        <tr>
          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.location") }}:</span></td>
          <td><span v-if="this.contractData.status === enumDef.trackPayStats.Tracking">{{ $t("trackPay.shipmentProgressStatus.tracked") }}</span></td>
        </tr>
<!--        <tr>-->
<!--          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.temperature") }}:</span></td>-->
<!--          <td><span>{{  }}</span></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.shock") }}:</span></td>-->
<!--          <td><span>{{  }}</span></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.dataRate") }}:</span></td>-->
<!--          <td><span>{{  }}</span></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.intensity") }}:</span></td>-->
<!--          <td><span>{{  }}</span></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td class="text_right"><span class="font_bold font_base"> {{ $t("trackPay.trackersForm.duration") }}:</span></td>-->
<!--          <td><span>{{  }}</span></td>-->
<!--        </tr>-->
      </table>
		</div>
		<div class="flex flex_between margin_top">
			<template v-if="!readOnly">
				<md-button class="md-blank" @click="back">{{
						$t("common.button.back")
					}}</md-button>
				<div v-if="!isDebtor">
					<md-button @click="save('save')" class="md-block margin_r">{{ $t("trackPay.process.save") }}
					</md-button>
					<md-button v-if="!contractData.id" @click="save('saveAndSend')" class="md-primary">{{ $t("trackPay.process.saveAndSend") }}
					</md-button>
					<md-button v-if="contractData.id" @click="save('send')" class="md-primary">{{ $t("trackPay.process.send") }}
					</md-button>
				</div>
				<div v-if="isDebtor">
					<md-button @click="next" class="md-primary" :class="{ 'md-primary': isFormValid }">{{ $t("common.continue") }}
					</md-button>
				</div>
			</template>
			<template v-else class="flex flex_between">
				<div></div>
				<md-button class="md-blank" @click="close">{{
						$t("common.button.close")
					}}</md-button>
			</template>
		</div>
	</div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";
import {trackPayApi} from "@/common/api/trackPayApi";
import {fileuploadApi} from "@/common/api/fileuploadApi";
import APP from "@/common/appConfig";
import {validateForm} from "src/validation/validation";
import {formatAsLocalizedEnum, formatAsMoneyAmount} from "@/common/format";
import {businessConfigApi} from "@/common/api/businessConfigApi";

export default {
	props: {
		readOnly: Boolean,
		contractData: Object,
		salesForm: Object,
		shipmentForm: Object,
		trackerForm: Object,
		isDebtor: Boolean
	},
	created() {
		businessConfigApi.getTrackAndPay().then(res => this.feeRate = res).catch(this.toast);

		if (this.contractData && this.contractData.id) {
		let generatedContractPdf;
		if (this.isDebtor) {
			generatedContractPdf = trackPayApi.debtor.getGeneratedContractPdf(this.contractData.id);
		} else {
			generatedContractPdf = trackPayApi.seller.getGeneratedContractPdf(this.contractData.id);
		}

		generatedContractPdf.then((res) => {
					if (res && res.fileId) {
						this.processData.downloadName = res.fileName;
						this.processData.downloadUrl = fileuploadApi.getPdfUrl(res.fileId)
					}
				}
			).catch(e => this.toast(e) )
		}
	},
  data() {
		return {
			enumDef: enumDef,
			feeRate: null,
			processData: {
				downloadUrl: `${APP.DOMAIN}platformdoc/track-and-pay-contract-example`,
				downloadName: this.$t(`trackPay.contractExample`),
			}
		};
	},
	methods: {
    formatAsLocalizedEnum(value) {
      return formatAsLocalizedEnum(enumDef.obligatory, value);
    },
    getSalesFormsShipment(name) {
      return this.salesForm && this.salesForm.form && this.salesForm.form.shipment && this.salesForm.form.shipment[name] || null;
    },
    getSalesForm(name) {
      return this.salesForm && this.salesForm.form && this.salesForm.form[name] || null;
    },
    getSalesFormAmount() {
      return this.getSalesForm('amount') || this.contractData.amount;
    },
    getModesOfTransportOfShipmentForm() {
      return this.shipmentForm && this.shipmentForm.form && this.shipmentForm.form.modesOfTransport || [];
    },
    getShipmentFormsShipment(name) {
      return this.shipmentForm && this.shipmentForm.form && this.shipmentForm.form.shipment && this.shipmentForm.form.shipment[name] || null;
    },
    getTrackerForm() {
      return this.trackerForm && this.trackerForm.form || null;
    },
    getFeeObligatory() {
      return this.contractData.feeObligatory;
    },
    formatAmount(value) {
      return formatAsMoneyAmount(value, {currency : this.getSalesForm("currency") || this.contractData.currency});
    },
    validate() {
      return validateForm(this, this.$validator);
    },
		back() {
			this.$emit("back");
		},
		close() {
			this.$emit("close");
		},
    save(type) {
      if ('saveAndSend' === type || 'send' === type) {
        this.validate()
            .then(() => {
              this.$emit("save", type);
            })
            .catch(this.toast);
      } else {
        this.$emit("save", type);
      }
    },
		next() {
			this.$emit("next");
		}
	}
};
</script>
<style lang="scss">
	.contract_summary {
		margin: 20px auto;
		padding: 10px;
		width: 800px;
		text-align: left;
	}
  td {
    width: 50%;
  }
</style>
